import styled from "styled-components";
import { Grid, Stack, Chip, Divider } from "@mui/material";
import font from "src/styles/font";
import { DarkGrey } from "src/styles/color";

import SpottableImage from "src/components/HotspotImage/SpottableImage";

const S = {};

S.MediaUploaded = styled.div`
  position: relative;
`;

const Step3 = ({ formData, formControl }) => {
  return (
    <Grid container>
      <Grid item md={5}>
        <S.MediaUploaded>
          <SpottableImage
            formControl={formControl} // just pass it to prevent error
            aspectRatio={1}
            previewImage={
              typeof formData?.media?.image === "string"
                ? formData?.media?.image
                : URL.createObjectURL(formData?.media?.image)
            }
            hotspot={formData?.media?.hotspot}
            mode={"view-only"}
            Components={{
              Hotspot: ({ index, ...props }) => {},
              HoverPopup: ({ index, ...props }) => {},
            }}
          />
        </S.MediaUploaded>
      </Grid>
      <Grid item md={7}>
        <Stack
          sx={{
            pl: 3,
          }}
        >
          <label
            style={{
              alignSelf: "flex-start",
              fontSize: font.size.md,
              marginBlock: 12,
              color: DarkGrey,
            }}
          >
            ชื่อภาพ
          </label>
          <Stack>{formData?.mood_name}</Stack>
          <Divider
            sx={{
              my: 2,
            }}
          />
          <label
            style={{
              alignSelf: "flex-start",
              fontSize: font.size.md,
              marginBlock: 12,
              color: DarkGrey,
            }}
          >
            ห้อง
          </label>
          <Stack>{formData?.room?.room_th}</Stack>
          <Divider
            sx={{
              my: 2,
            }}
          />
          <label
            style={{
              alignSelf: "flex-start",
              fontSize: font.size.md,
              marginBlock: 12,
              marginTop: 0,
              color: DarkGrey,
            }}
          >
            สไตล์
          </label>
          <Stack direction="row" gap={1}>
            {formData?.styles?.map((style) => (
              <Chip key={style?.name} label={style?.name} variant="outlined" />
            ))}
          </Stack>
          <Divider
            sx={{
              my: 2,
            }}
          />
          <label
            style={{
              alignSelf: "flex-start",
              fontSize: font.size.md,
              marginBlock: 12,
              marginTop: 0,
              color: DarkGrey,
            }}
          >
            แฮชแท็ก
          </label>
          <Stack direction="row" gap={1}>
            {formData?.hashtags?.map((tag) => (
              <Chip
                key={tag?.name}
                label={`#${tag?.name}`}
                variant="outlined"
              />
            ))}
          </Stack>
        </Stack>
      </Grid>
    </Grid>
  );
};
export default Step3;
